export default "__VITE_ASSET__60cfd687__"